export default "__VITE_ASSET__C2c4BBLb__"